<template>
  <div class="prodlines-component">
    <div class="area">
      <div class="row prodlines-container" v-animated-show="utils.handleScroll">
        <section class="main-desc col-4 col-md-12 gap-offset">
          <Description
            class="main default"
            ref="mainDescription"
            :title="info.title"
            :desc="info.desc"
            :button="info.button"
            :href="info.href"
          />
        </section>
        <div class="spacer col-6 md-hidden"></div>
        <div class="spacer col-1 md-hidden"></div>
        <section
          class="list-section-banner col-md-12 gap-offset"
          :class="[
            'block-' + (i + 1),
            {
              'col-3': l.title,
            },
          ]"
          v-for="(l, i) in list"
          :key="i"
        >
          <div class="content">
            <a :href="l.href">
              <Description
                class="small icon-top icon-top-small"
                ref="bannerDescription"
                :title="l.title"
                :desc="l.desc"
                :list="l.list"
                :button="l.button"
                :more="l.newTitle"
                href="/product"
                :icon="l.icon"
                v-if="l.title"
              />
            </a>
            <div class="images">
              <img
                v-for="(o, index) in l.images"
                :src="o.src"
                :alt="o.alt"
                :key="index"
              />
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
export default {
  name: "ProdLines",
  props: {
    info: Object,
    list: Array,
  },
  data() {
    return { utils: utils };
  },
};
</script>

<style lang="scss">
.prodlines-component {
  @media all and (max-width: $lg) {
    margin-top: -30px;
  }
  position: relative;
  z-index: 0;
  background-size: cover;
  position: relative;
  @extend %page-block;
  &::before {
    @media all and (max-width: $lg) {
      left: -150px;
      top: 340px;
    }
    @media all and (max-width: $md) {
      left: -150px;
      top: 140px;
      width: 350px;
      height: 450px;
    }
    pointer-events: none;
    content: "";
    position: absolute;
    background: url(../assets/photos/main/wheat1.png) no-repeat right center;
    left: -70px;
    min-width: 300px;
    width: calc((100vw - 1088px) / 2 + 180px);
    height: calc((100vw - 1088px) / 2 + 280px);
    max-width: 600px;
    max-height: 600px;
    background-size: contain;
    top: 200px;
    mix-blend-mode: multiply;
    z-index: 1;
  }
  &::after {
    @media all and (max-width: $lg) {
      right: -150px;
    }
    @media all and (max-width: $md) {
      right: -180px;
      top: 340px;
      width: 350px;
      height: 450px;
    }
    content: "";
    position: absolute;
    background: url(../assets/photos/main/wheat2.png) no-repeat left center;
    right: -150px;
    min-width: 300px;
    max-width: 600px;
    max-height: 600px;
    width: calc((100vw - 1088px) / 2 + 180px);
    height: calc((100vw - 1088px) / 2 + 280px);
    background-size: contain;
    top: 240px;
    mix-blend-mode: multiply;
  }
  .area {
  }
  .prodlines-container {
    grid-row-gap: 26px;
  }
  .main-desc {
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
      margin-bottom: 42px;
    }
    grid-column: 2 / span 5;
  }
  .list-section-banner {
    .content {
      display: grid;
      a {
        position: relative;
        z-index: 2;
        transition: color 0.5s;
        .icon {
          &::before {
            transition: color 0.5s;
            color: $text-main !important;
          }
        }
        &:hover {
          border-color: transparent;
          color: $color-accent;
          .icon {
            &::before {
              color: $color-accent !important;
            }
          }
        }
      }
    }
    .description {
      @media all and (max-width: $md) {
        justify-content: center;
        justify-items: center;
      }
    }
    .images {
      img {
        object-fit: contain;
      }
    }
    .icon {
      margin-left: -4px;
      &.icon-cake {
        margin-left: -6px;
      }
    }
    .more {
      @extend %strip;
      align-self: center;
      justify-self: flex-start;
      padding: 0 20px;
      line-height: 24px;
      margin-top: -10px;
    }
    &.block-1 {
      @media all and (max-width: $md) {
        grid-column: 1 / span 12;
        margin-top: 0px;
      }
      margin-top: 50px;
      grid-column: 2 / span 4;
      .icon {
        font-size: 24px;
      }
      .images {
        @media all and (max-width: $md) {
          display: grid;
          justify-content: center;
          justify-items: center;
        }
        img {
          @media all and (max-width: $md) {
            position: unset;
            width: 100%;
            max-width: 306px;
            object-position: center center;
          }
          width: 301px;
          height: 287px;
          position: relative;
          left: -30px;
          margin-top: 30px;
        }
      }
    }
    &.block-2 {
      @media all and (max-width: $md) {
        grid-column: 1 / span 12;
      }
      grid-column: span 4;
      .icon {
        font-size: 28px !important;
      }
      .images {
        @media all and (max-width: $md) {
          display: grid;
          justify-content: center;
          justify-items: center;
          grid-row: unset;
        }
        position: relative;
        grid-row: 1;
        img:first-child {
          width: 309px;
          height: 248px;
          position: relative;
          left: -30px;
          margin-top: 30px;
        }
        img:nth-child(2) {
          @media all and (max-width: $md) {
            display: none;
          }
          position: absolute;
          right: -325px;
          top: 117px;
          width: 375px;
          height: 321px;
        }
      }
    }
    &.block-3 {
      @media all and (max-width: $md) {
        grid-column: 1 / span 12;
        top: 0;
      }
      position: relative;
      top: -74px;
      .icon {
        font-size: 28px !important;
      }
      .images {
        @media all and (max-width: $md) {
          grid-auto-rows: 150px;
        }
        display: grid;
        top: -60px;
        position: relative;
        img:first-child {
          @media all and (max-width: $md) {
            right: unset;
            top: unset;
            left: 80px;
            justify-self: center;
            position: relative;
          }
          position: absolute;
          width: 284px;
          height: 259px;
          position: relative;
          left: -252px;
          top: -277px;
        }
        img:nth-child(2) {
          @media all and (max-width: $md) {
            right: unset;
            top: -44px;
            left: -127px;
            justify-self: center;
            position: relative;
          }
          position: absolute;
          left: 00px;
          top: -368px;
          width: 292px;
          height: 338px;
        }
        img:nth-child(3) {
          @media all and (max-width: $md) {
            left: 70px;
            top: unset;
            position: relative;
            justify-self: center;
            align-self: flex-end;
            top: 50px;
          }
          position: absolute;
          right: -176px;
          top: -221px;
          width: 226px;
          height: 226px;
        }
      }
    }
  }
}
</style>
